// Standardized customer-facing carrier list.
export const SHIPPING_PROVIDERS = {
  CCCC_BIKE_COURIER: 'CCCC Bike Courier',
  DHL: 'DHL',
  DHL_EXPRESS: 'DHL Express',
  DHL_INTERNATIONAL: 'DHL International',
  FEDEX: 'FedEx',
  OTHER: 'Other',
  PERSONAL_HANDOVER: 'Personal handover',
  PUROLATOR: 'Purolator',
  SELF_PICKUP: 'Self pickup',
  SWISS_POST: 'Swiss Post',
  UPS: 'UPS',
  USPS: 'USPS',
}

// Dropdown display order defined by SM-2350, "Other" last.
export const ORDERED_SHIPPING_PROVIDERS = [
  SHIPPING_PROVIDERS.DHL,
  SHIPPING_PROVIDERS.DHL_EXPRESS,
  SHIPPING_PROVIDERS.DHL_INTERNATIONAL,
  SHIPPING_PROVIDERS.UPS,
  SHIPPING_PROVIDERS.USPS,
  SHIPPING_PROVIDERS.SWISS_POST,
  SHIPPING_PROVIDERS.CCCC_BIKE_COURIER,
  SHIPPING_PROVIDERS.FEDEX,
  SHIPPING_PROVIDERS.PERSONAL_HANDOVER,
  SHIPPING_PROVIDERS.PUROLATOR,
  SHIPPING_PROVIDERS.SELF_PICKUP,
  SHIPPING_PROVIDERS.OTHER,
]
